import { render, staticRenderFns } from "./ExternalProjectsList.vue?vue&type=template&id=ca6aace2&scoped=true&"
import script from "./ExternalProjectsList.vue?vue&type=script&lang=js&"
export * from "./ExternalProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ExternalProjectsList.vue?vue&type=style&index=0&id=ca6aace2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6aace2",
  null
  
)

export default component.exports